<template>
  <div class="go-in">
    <div class="introduction" id="intro" :style="`height:${pageLoading?'3rem':'auto'};`" v-loading="pageLoading">
      <TitleTips :routerList="routerList" routeType="/gywm/companyIntroduction" title="公司介绍"/>
      <div style="display:flex;justify-content:center;">
        <span style="font-size:0.14rem;color: #686868;"  v-html="pageObj.txt"></span>
      </div>
    </div>
  </div>
</template>

<script>
import TitleTips from "../components/TitleTips.vue";
import http from '../utils/http'
export default {
  components: {
    TitleTips
  },
  data() {
    return {
      pageLoading:false,
      imgUrlBanner: '',
      pageObj: {},
      routerList:[]
    };
  },
  created(){
        this.pageLoading=true
        http.post("/reception/about/getCompanyProfilePage",{groupType:'105',  title:'hhhh'})
        .then(res => {
          this.pageObj = Object.assign({},res.data);
        }).finally(()=>{
          this.pageLoading=false
          // let loadingInstance = Loading.service({target:'intro'});
          // loadingInstance.close();
        })
  },
  mounted() {
    this.routerList=this.$route.matched
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}

.go-in {
  .introduction{
    width: 100%;
    box-sizing: border-box;
    padding:0rem 1rem 0.5rem 1rem ;
  }
}
</style>